import { render } from "./legacyResource.vue?vue&type=template&id=2e41e833&scoped=true"
import script from "./legacyResource.vue?vue&type=script&lang=js"
export * from "./legacyResource.vue?vue&type=script&lang=js"

import "./legacyResource.vue?vue&type=style&index=0&id=2e41e833&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e41e833"]])

export default __exports__